/*--------------------------------------------------------------

	base

	@version 19.4.1

---------------------------------------------------------------*/

jQuery(function ($) {
	const breakpoint = [600, 960],
		frameSetting = {
			hws: {
				type: {
					sp: 'a',
					spyoko: 'c', // sp横向き ※ 'c'推奨
					tb: 'a',
					pc: 'a',
				},
				opt: {
					sp: { adjust: 200 },
					spyoko: { adjust: 200 },
					tb: { adjust: 200 },
					pc: { adjust: 500 },
				},
			},
			gnoTop0: false,
		};

	//スマホでの各種ヘッダーメニューの開閉
	function opencloseHeadernav() {
		var handles = document.querySelectorAll('[data-openclose-headernav="handle"]');
		var targets = document.querySelectorAll('[data-openclose-headernav="target"]');

		handles.forEach(function (handle) {
			handle.addEventListener('click', function () {
				var targetId = handle.getAttribute('data-target');
				var targetElement = document.getElementById(targetId);

				// クリックされたhandleの対応するtargetに.openを付与・削除
				if (targetElement) {
					targetElement.classList.toggle('open');
				}

				// クリックされたhandle自体に.openクラスを付与・削除
				handle.classList.toggle('open');

				// クリックされたhandle以外のtarget要素とhandle要素から.openクラスを削除
				handles.forEach(function (otherHandle) {
					if (otherHandle !== handle) {
						otherHandle.classList.remove('open');
					}
				});

				targets.forEach(function (otherTarget) {
					if (otherTarget !== targetElement) {
						otherTarget.classList.remove('open');
					}
				});

				// .nav_openクラスの付与判定
				var isOpen = Array.from(targets).some(function (target) {
					return target.classList.contains('open');
				});

				// bodyに.nav_openクラスの付与・削除
				document.body.classList.toggle('nav_open', isOpen);
			});
		});
	}

	function changed(mode) {
		if (mode === 'sp') {
			$('[data-openclose-sp="handle"]').openclose({ off: false });
			$('[data-openclose-sp="handle"]').attr('href', 'javascript: void(0)');
		} else if (mode === 'sp_tb') {
			$('[data-openclose-sptb="handle"]').openclose({ off: false });
			$('[data-openclose-sptb="handle"]').attr('href', 'javascript: void(0)');
		} else if (mode === 'tb') {
		} else if (mode === 'tb_pc') {
			$('[data-openclose-sp="handle"]').openclose({ off: true });
		} else if (mode === 'pc') {
			$('[data-openclose-sptb="handle"]').openclose({ off: true });
		} else if (mode === 'every') {
			$('img[data-switchimg]').switchImg({ breakPoint: breakpoint });
			$('#gnav [data-submenu="wrap"]').navSubmenu();
			$('[data-link="sscroll"]').sScroll();
		}
	}

	function setup() {
		/* frame ( oo_lib ) */
		$('#gnav').navCurrent();
		$('[data-nav="sidenav"]').navCurrent({ gnav: false });
		$('#pagetop').sScroll({ top: true });
		$('#pagetop').pagetopDisplayAnimation();
		$.oo.frame(frameSetting);

		/* utility ( oo_lib ) */
		$('[data-modal="handle"]').modal();
		$('[data-slide="wrap"]').slide();
		$('[data-openclose="handle"]').openclose();
		$('[data-tab="handles"]').switchTab();
		$('[data-gallery="handles"]').imgGallery();
		$('.snap_sp').snapDots();
		$('[data-tooltip]').tooltip();

		/* auto ( oo_lib ) */
		$('body').hashLinkInPage();
		$('a[href$=".pdf"]').gaDownloadTrack();
		$('a[href$=".pdf"]').addTargetBlank();
		$.oo.inheritTeston();

		/* form ( oo_lib ) */
		$('input[name="password"] +.icon_eye').inputPasswordChange();
		$.oo.inputFile();
	}

	$(function () {
		$.oo.changed_run(changed, breakpoint);
		setup();
		opencloseHeadernav();
	});
});

/*------------------------------------------------
	load
------------------------------------------------*/

// setTimeout(function () {
// 	$('#loading_wrap').fadeOut();
// 	$('body').css({ opacity: 100 });
// }, 1000);
$(window).on('load', function () {
	// $('#loading_wrap').fadeOut();
	// $('body').css({ opacity: 100 });
	$('#contaiiner').css({ paddingTop: $('#header_wrap').outerHeight() });
});
